import { createField } from "./inform-info.section";
import lodash from "lodash";

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const isLoading = props.isLoading;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    data.fields = createField({ props, data, refs, key, isLoading });
    if (model.id) {
        data.product = {
            fetchCriteria: {
                select: ["**", "refHazObject.**"],
                page: 0,
                size: 1000000,
                where: [{ name: "refInform.id", type: "UUID", operator: "=", value: model.id }],
                sort: [{ name: "createDate", type: "ASC" }],
                children: [{ name: "addresses", select: ["**"], page: 0, size: 1000000 }]
            }
        };
    }
};
